import Nominations from '@/services/Api/Awards/Nominations';
import { handleAuthorization, handleFormValidations } from '@ifac/ui';

export default {
  methods: {
    mx_fetchNomination() {
      return Nominations.get(this.mx_nominationId);
    },
    mx_createNomination(award, payload) {
      return Nominations.create(award.id, {
        form_values: payload,
      }).then(() => {
        this.$snack.success({ text: 'Nomination created' });
        this.$router.push({ name: 'Nominations' });
      }).catch((error) => {
        this.handleError(error);
        throw error;
      });
    },
    mx_updateNomination(payload) {
      this.formErrors = {};
      return Nominations
        .update(this.nomination.id, {
        form_values: payload,
      })
        .then((response) => {
          this.$snack.success({ text: 'Nomination saved' });
          return response;
        })
        .catch((error) => {
        this.handleError(error);
      });
    },
    mx_cancelNomination() {
      Nominations.delete(this.nomination.id).then(() => {
        this.$router.push({ name: 'Nominations' });
      });
    },
    mx_submitNomination(payload) {
      this.formErrors = {};
      return Nominations.submit(this.nomination.id, {
        form_values: payload,
      }).then((response) => {
        this.$snack.success({ text: 'Nomination submitted' });
        this.$router.push({ name: 'Nominations' });
        return response;
      }).catch((error) => {
          this.handleError(error);
      });
    },
    handleError(error) {
      handleAuthorization(error).then((msg) => {
        if (msg) {
          this.$snack.success({ text: msg });
        }
      });

      handleFormValidations(error).then((errors) => {
        if (errors) {
          this.$snack.success({
            text: 'You have some validation errors, try again please.',
          });
          this.formErrors = errors;
        }
      });
    },
  },
  computed: {
    mx_nominationId() {
      return this.$route.params.nomination;
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch('awards/setCurrentAward', null);
    next();
  },
};
